import Credentials from './Credentials'

export default Credentials